import React from "react";
import "./marquee.component.styles.scss";
import { useLang } from "../../../lib/i18n";

type Item = { it: string; en: string; tone: "name" | "verb" };

// Wellness verbs in italic paired with treatment names, separated
// by a single sage dot — quiet rhythm, no ornaments.
const items: Item[] = [
  { it: "Respirare", en: "Breathe", tone: "verb" },
  { it: "Massaggio Svedese", en: "Swedish Massage", tone: "name" },
  { it: "Rallentare", en: "Slow down", tone: "verb" },
  { it: "Californiano", en: "Californian", tone: "name" },
  { it: "Sciogliere", en: "Release", tone: "verb" },
  { it: "Ayurvedico", en: "Ayurvedic", tone: "name" },
  { it: "Allentare", en: "Loosen", tone: "verb" },
  { it: "Decontratturante", en: "Deep-Tissue", tone: "name" },
  { it: "Ascoltarsi", en: "Listen inward", tone: "verb" },
  { it: "Linfodrenante", en: "Lymphatic Drainage", tone: "name" },
  { it: "Lasciar andare", en: "Let go", tone: "verb" },
  { it: "Aromaterapia", en: "Aromatherapy", tone: "name" },
  { it: "Prendersi cura", en: "Take care", tone: "verb" },
  { it: "Skin Care", en: "Skin Care", tone: "name" },
];

const Marquee: React.FC = () => {
  const { lang } = useLang();
  const localized = items.map((it) => ({
    label: lang === "en" ? it.en : it.it,
    tone: it.tone,
  }));
  const doubled = [...localized, ...localized];
  return (
    <div className="lvs-marquee" aria-hidden="true">
      <div className="lvs-marquee__track">
        {doubled.map((it, i) => (
          <span
            key={i}
            className={`lvs-marquee__item lvs-marquee__item--${it.tone}`}
          >
            <span className="lvs-marquee__label">{it.label}</span>
            <span className="lvs-marquee__sep">·</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
